import { FallbackProps } from "react-error-boundary";

const GeneralError = ({ error, resetErrorBoundary }: FallbackProps) => {
  return (
    <div className="p-3 text-[14px]">
      Error: {error.message}. Click{" "}
      <strong>
        <a onClick={resetErrorBoundary}>here</a>
      </strong>{" "}
      to try again
    </div>
  );
};

export const CustomError = (message: string) => {
  return ({ resetErrorBoundary }: FallbackProps) => {
    return (
      <div className="p-3 text-[14px]">
        {message}. Click{" "}
        <strong>
          <a onClick={resetErrorBoundary}>here</a>
        </strong>{" "}
        to try again
      </div>
    );
  };
};

export default GeneralError;
